const storageKey = (listPath) => `od:list:${listPath}`;

const isEmpty = (value) => value === "" || value == null || (Array.isArray(value) && value.length === 0);

const sameValue = (a, b) => (Array.isArray(a) || Array.isArray(b)
  ? JSON.stringify(a || []) === JSON.stringify(b || [])
  : String(a) === String(b));

export const readListParams = (defaults) => {
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => {
    if (Array.isArray(fallback)) {
      const values = params.getAll(`${key}[]`);
      return [key, values.length ? values : fallback];
    }
    if (!params.has(key)) return [key, fallback];
    const raw = params.get(key);
    if (typeof fallback === "number") {
      const n = Number(raw);
      return [key, raw !== "" && Number.isInteger(n) && n >= 1 ? n : fallback];
    }
    return [key, raw];
  }));
};

export const rememberListUrl = (listPath) => {
  try {
    if (window.location.pathname === listPath) {
      window.sessionStorage.setItem(storageKey(listPath), `${window.location.pathname}${window.location.search}`);
    }
  } catch (e) {
    return undefined;
  }
  return undefined;
};

export const writeListParams = (listPath, values, defaults) => {
  const url = new URL(window.location.href);
  Object.keys(defaults).forEach((key) => {
    url.searchParams.delete(key);
    url.searchParams.delete(`${key}[]`);
    const value = values[key];
    if (isEmpty(value) || sameValue(value, defaults[key])) return;
    if (Array.isArray(value)) value.forEach((v) => url.searchParams.append(`${key}[]`, v));
    else url.searchParams.set(key, value);
  });
  window.history.replaceState(window.history.state, "", url);
  rememberListUrl(listPath);
};

export const listHref = (listPath) => {
  try {
    const remembered = window.sessionStorage.getItem(storageKey(listPath));
    if (remembered && (remembered === listPath || remembered.startsWith(`${listPath}?`))) return remembered;
  } catch (e) {
    return listPath;
  }
  return listPath;
};
